import { 
    BASE_URL,
    KEYMAKER_URL,
    GET_PLUGIN_URL,
    PRICE_URL,
    REFERRAL_URL,
    ADOBE_RATING_URL,
  } from "@app/routes";

export const HEADER_NAVIGATION_LOGO = [
    { title: 'LOGO', path: BASE_URL, ico:"/images/main_logo-b.png", classes:'header__logo-icon' },
]

export const HEADER_NAVIGATION_LOGO_CUT = [
    { title: 'LOGO', path: BASE_URL, ico:"/images/logo.png", classes:'header__logo-icon' },
]

export const HEADER_NAVIGATION_LINKS= [
    ...HEADER_NAVIGATION_LOGO,
    { title: 'KeyMaker', path: KEYMAKER_URL },
    { title: 'Get plugin', path: GET_PLUGIN_URL },
    { title: 'Adobe rating', path: ADOBE_RATING_URL, classes: "bold-color" },
    { title: 'Price', path: PRICE_URL },
    { title: 'Free month', path: REFERRAL_URL, classes: "bold-color" },
];

